import {EventDispatcher, EventHandler} from "./EventDispatcher";

export interface Task {
    id: number;
    data: any;
}

export class TaskManager {
    newTaskDispatcher: EventDispatcher<Task>;
    removeTaskDispatcher: EventDispatcher<Task>;
    running: Map<number, Task>;
    processes: number;

    constructor() {
        this.running = new Map<number, Task>();
        this.processes = 0;
        this.newTaskDispatcher = new EventDispatcher<Task>();
        this.removeTaskDispatcher = new EventDispatcher<Task>();
    }

    addTask(data: any): Task {
        const task: Task = {
            id: ++this.processes,
            data: data,
        };
        this.running.set(task.id, task);
        this.newTaskDispatcher.handle(task);
        return task;
    }

    removeTask(id: number) {
        const task = this.running.get(id);
        if (task !== undefined) {
            this.running.delete(id);
            this.removeTaskDispatcher.handle(task);
        }
    }

    onNewTask(newTaskHandler: EventHandler<Task>) {
        this.newTaskDispatcher.register(newTaskHandler);
    }

    onRemoveTask(removeTaskHandler: EventHandler<Task>) {
        this.removeTaskDispatcher.register(removeTaskHandler);
    }
}